module.exports = __webpack_public_path__ + "static/8-cd3496ade357cb9a4d16582bdab11360.jpg";